<template>
  <div class="request-payment-summary">
    <div>
      <span>Associates</span>
      <strong>{{ summary.associates }}</strong>
    </div>
    <div>
      <span>Selected shifts</span>
      <strong>{{ summary.shifts }}</strong>
    </div>
    <div>
      <span>Paid hours</span>
      <strong>{{ summary.hours.toFixed(2) }}</strong>
    </div>
    <div>
      <span>Total</span>
      <strong>{{ formatMoney(summary.amount) }}</strong>
    </div>
  </div>
</template>

<script>
import { formatRequestPaymentMoney } from '../../services/request-payment-utils'

export default {
  props: {
    summary: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatMoney: formatRequestPaymentMoney
  }
}
</script>

<style scoped>
.request-payment-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1px;
  overflow: hidden;
  border: 1px solid var(--border-color-base);
  border-radius: 8px;
  background: var(--border-color-base);
}
.request-payment-summary > div {
  padding: 12px 16px;
  background: var(--bg-card);
}
.request-payment-summary span {
  display: block;
  margin-bottom: 5px;
  color: var(--text-secondary);
}
.request-payment-summary strong {
  font-size: 20px;
}
@media (max-width: 720px) {
  .request-payment-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
